import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import Container from './common/Container';
import videoBg from '../assets/Assemble_Video_Ready11.mp4';

const ParallaxVideo = () => {
    const sectionRef = useRef(null);
    const { scrollYProgress } = useScroll({
        target: sectionRef,
        offset: ["start end", "end start"]
    });

    const scale = useTransform(scrollYProgress, [0, 1], [1.2, 1]);
    const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0.5, 1, 1, 0.5]);

    return (
        <section ref={sectionRef} className="py-20 bg-primary relative overflow-hidden min-h-[100vh] flex items-center justify-center">

            {/* Parallax Background */}
            <motion.div
                className="absolute inset-0 z-0"
                style={{ scale, opacity }}
            >
                <video
                    className="absolute inset-0 w-full h-full object-cover"
                    src={videoBg}
                    autoPlay
                    loop
                    muted
                    playsInline
                />
                <div className="absolute inset-0 bg-primary/20" />
            </motion.div>

            <Container className="relative z-10 text-center">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >
                    <span className="inline-block py-1 px-3 border border-white/30 rounded-full text-white/80 text-xs font-bold tracking-widest uppercase mb-6 backdrop-blur-sm">
                        Experience Luxury
                    </span>
                    <h2 className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold text-white mb-8 tracking-tight">
                        Building Tomorrow.<br />Today.
                    </h2>
                    <p className="text-gray-300 max-w-2xl mx-auto text-lg md:text-xl font-light leading-relaxed">
                        We don't just build structures. We craft lifestyles that inspire.
                    </p>
                </motion.div>
            </Container>
        </section>
    );
};

export default ParallaxVideo;
